(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
// Get the moreless-button element
var morelessButton = document.querySelector('.moreless-button');

// Get the moretext element
var moretextElement = document.querySelector('.moretext');

// Add a click event listener to the button
morelessButton.addEventListener('click', function() {
  // Toggle the display of the moretext element
  if (moretextElement.style.display === 'none' || moretextElement.style.display === '') {
    moretextElement.style.display = 'block';
    morelessButton.textContent = 'Read less';
  } else {
    moretextElement.style.display = 'none';
    morelessButton.textContent = 'Read more';
  }
});

  } catch(e) { console.error(e); }
})();
})();
